<app-loading
  [loading] = loading
></app-loading>

<div class="modal-overlay" *ngIf="modalNova" (click)="!loading && fecharModal()">
  <div class="box-nova-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-check-square"></i> Nova Tarefa
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-12">
        <label for="descricao" class="form-label">Descrição</label>
        <input type="text" class="form-control" name="descricao" id="descricao" [(ngModel)]="tarefa.descricao"
               #descricao="ngModel" required
               [ngClass]="{'is-invalid': (descricao.invalid && (descricao.dirty || descricao.touched)) || (!tarefa.descricao && (descricao.dirty || descricao.touched))}"
               placeholder="Digite a descrição da tarefa">
        <div class="invalid-feedback" *ngIf="(descricao.invalid && (descricao.dirty || descricao.touched)) || (!tarefa.descricao && (descricao.dirty || descricao.touched))">
          A descrição é obrigatória.
        </div>
      </div>

      <div *ngIf="!telaProcesso" class="col-md-12">
        <label class="form-label d-block">Vincular a:</label>
        <div class="d-flex gap-3">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="tipoVinculo" id="vinculoNenhum" value="nenhum" [(ngModel)]="tipoVinculo">
            <label class="form-check-label" for="vinculoNenhum">Nenhum</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="tipoVinculo" id="vinculoProcesso" value="processo" [(ngModel)]="tipoVinculo">
            <label class="form-check-label" for="vinculoProcesso">Processo</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="tipoVinculo" id="vinculoAtendimento" value="atendimento" [(ngModel)]="tipoVinculo">
            <label class="form-check-label" for="vinculoAtendimento">Atendimento</label>
          </div>
        </div>
      </div>

      <div *ngIf="!telaProcesso && tipoVinculo === 'processo'" class="col-md-12">
        <label for="processos" class="form-label">Processo</label>
        <ng-select [(ngModel)]="tarefa.processoId"
                   [items]="processos.itens"
                   bindLabel="titulo"
                   bindValue="id"
                   placeholder="Selecione"
                   id="processos">
        </ng-select>
      </div>

      <div *ngIf="!telaProcesso && tipoVinculo === 'atendimento'" class="col-md-12">
        <label for="atendimentos" class="form-label">Atendimento</label>
        <ng-select [(ngModel)]="tarefa.atendimentoId"
                   [items]="atendimentos.itens"
                   bindLabel="descricaoResumida"
                   bindValue="id"
                   placeholder="Selecione"
                   id="atendimentos">
        </ng-select>
      </div>

      <div class="col-md-12">
        <label for="tipoTarefa" class="form-label">Tipo da Tarefa</label>
        <ng-select [(ngModel)]="tarefa.tipoTarefaId"
                   [items]="tiposTarefa"
                   bindLabel="descricao"
                   bindValue="id"
                   placeholder="Selecione"
                   id="tipoTarefa"
                   #tipoTarefa="ngModel" required
                   [ngClass]="{'is-invalid': (tipoTarefa.invalid && (tipoTarefa.dirty || tipoTarefa.touched)) || (!tarefa.tipoTarefaId && (tipoTarefa.dirty || tipoTarefa.touched))}">
        </ng-select>
        <div class="invalid-feedback d-block" *ngIf="(tipoTarefa.invalid && (tipoTarefa.dirty || tipoTarefa.touched)) || (!tarefa.tipoTarefaId && (tipoTarefa.dirty || tipoTarefa.touched))">
          O tipo da tarefa é obrigatório.
        </div>
      </div>

      <div class="col-md-6">
        <label for="valor" class="form-label">Valor</label>
        <input type="text" class="form-control" name="valor" id="valor" [(ngModel)]="tarefa.valor"
               mask="separator.2" prefix="R$ " thousandSeparator="." decimalMarker="," [dropSpecialCharacters]="true"
               #valor="ngModel" required
               [ngClass]="{'is-invalid': (valor.invalid && (valor.dirty || valor.touched)) || ((tarefa.valor === null || tarefa.valor === undefined || tarefa.valor.toString() === '') && (valor.dirty || valor.touched))}">
        <div class="invalid-feedback" *ngIf="(valor.invalid && (valor.dirty || valor.touched)) || ((tarefa.valor === null || tarefa.valor === undefined || tarefa.valor.toString() === '') && (valor.dirty || valor.touched))">
          O valor é obrigatório.
        </div>
      </div>

      <div class="col-md-6">
        <label for="dataPrevisao" class="form-label">Previsão de término</label>
        <input type="date" class="form-control" name="dataPrevisao" id="dataPrevisao" [(ngModel)]="tarefa.dataPrevisaoFinalizacao"
               #dataPrevisao="ngModel" required
               [ngClass]="{'is-invalid': (dataPrevisao.invalid && (dataPrevisao.dirty || dataPrevisao.touched)) || (!tarefa.dataPrevisaoFinalizacao && (dataPrevisao.dirty || dataPrevisao.touched))}">
        <div class="invalid-feedback" *ngIf="(dataPrevisao.invalid && (dataPrevisao.dirty || dataPrevisao.touched)) || (!tarefa.dataPrevisaoFinalizacao && (dataPrevisao.dirty || dataPrevisao.touched))">
          A previsão de término é obrigatória.
        </div>
      </div>

      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-light" (click)="fecharModal()" [disabled]="loading">Cancelar</button>
        <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="loading || !isFormValido()">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ loading ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>
</div>

